import { useMemo } from "react";
import type { UserType } from "../types";

interface UseFilterOptionsProps {
  users: UserType[];
}

interface UseFilterOptionsReturn {
  uniqueCities: string[];
  uniqueIndustries: string[];
  uniquePositions: string[];
}

export function useFilterOptions({
  users,
}: UseFilterOptionsProps): UseFilterOptionsReturn {
  // Generate unique cities from users data
  const uniqueCities = useMemo(() => {
    const allCities = Array.from(
      new Set(
        users
          .map((user) => user.city)
          .filter((city) => city && city.trim() !== ""),
      ),
    ).sort();

    // Prioritize Moscow and Saint Petersburg
    const priorityCities = ["Москва", "Санкт-Петербург"];
    const priority = priorityCities.filter((city) => allCities.includes(city));
    const others = allCities.filter((city) => !priorityCities.includes(city));

    return [...priority, ...others];
  }, [users]);

  // Generate unique industries from users data (comma-separated parsing)
  const uniqueIndustries = [
    "Банки, страхование, финансы",
    "Консалтинг, профессиональные услуги",
    "ИТ, Digital и Телеком",
    "Строительство, недвижимость",
    "Розничная и оптовая торговля, HoReCa",
    "Медицина, фармацевтика",
    "Производство",
    "Логистика, транспорт",
    "Образование, наука, НКО",
    "Нефтегаз, энергетика, добывающая промышленность",
  ];

  // Generate unique positions from users data (comma-separated parsing)
  const uniquePositions = [
    "Собственник",
    "CEO / COO",
    "Производство",
    "Маркетинг и PR",
    "Продажи",
    "Продукт, стратегия и развитие",
    "Финансы / бухгалтерия",
    "Закупки",
    "IT",
    "HR",
  ];

  return {
    uniqueCities,
    uniqueIndustries,
    uniquePositions,
  };
}
